<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('edit') }} {{ $t('contract') }}</div>
      <router-link class="btn-blue" to="contract">{{ $tc('contract', 2) }} {{ $tc('list', 2) }}</router-link>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-2 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="contract_name"
                name="Contract Name"
                id="Contract Name"
                v-validate="'required'"
                v-b-tooltip.hover
                 :title="$t('contract_name_tooltip')"
              />
              <label>{{ $tc('name',2) }}</label>
            </div>
            <!--Tooltip :title="$t('contract_name_tooltip')" /-->
          </div>
          <p class="error_message">
            <span
              v-if="submitted && errors.has('Contract Name')"
            >{{ errors.first('Contract Name') }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-2 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
              style="text-align:right"
                placeholder="."
                type="number"
                v-model="contract_value"
                name="Contract Value"
                id="Contract Value"
                v-validate="'required|max_value:100|min_value:1'"
                v-b-tooltip.hover
                :title="$t('contract_value_tooltip')"
              />
              <label>{{ $tc("distributor", 2) }} {{ $tc("share", 2) }}</label>
            </div>
            <!--Tooltip :title="$t('contract_value_tooltip')" /-->
          </div>
          <p class="error_message">
            <span
              v-if="submitted && errors.has('Contract Value')"
            >{{ errors.first('Contract Value') }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="contract_description"
                name="Contract Name"
                id="Contract Name"
                v-b-tooltip.hover
                  :title="$t('contract_description_tooltip')"
              />
              <label>{{ $tc('description',2) }}</label>
            </div>
            <!--Tooltip :title="$t('contract_description_tooltip')" /-->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        

        <div class="col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t('isPercentage') }}</label>
            <label class="mb-0 ml-2">
              <b-form-checkbox v-model="contract_is_percentage" type="checkbox" class="j-checkbox" checked />
              
            </label>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-1 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t('active') }}</label>
            <label class="mb-0 ml-2">
              <b-form-checkbox v-model="contract_is_active" type="checkbox" class="j-checkbox" checked />
           
            </label>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-2">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit()"
            class="btn-blue"
          >{{ $t('update') }}</button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">{{ $t('reset') }}</button>
          <b-button class="btn-outline-grey" variant="default" to="/distributor/contract">{{ $t('cancel') }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import DistributorService from "@/services/DistributorService";

export default {
  data() {
    return {
      btenable: false,
      contract_id: null,
      submitted: false,
      contract_name: "",
      contract_description: "",
      contract_value: 0,
      contract_is_percentage: true,
      contract_is_active: true
    };
  },
  mounted() {
    this.contract_id = this.$route.query.contract_id;
    if (this.contract_id) {
      this.getContractDetails();
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    getContractDetails: function() {
      let payload = {
        contract_id: this.contract_id
      };
      DistributorService.GetSingleContractDetails(payload)
        .then(response => {
          this.btenable = false;
          const { data } = response;
          if (data && data.status) {
            let obj = data.Records;
            this.contract_name = obj.contract_name;
            this.contract_description = obj.contract_description;
            this.contract_value = obj.contract_value;
            this.contract_is_percentage =
              obj.contract_is_percentage == "Y" ? true : false;
            this.contract_is_active =
              obj.contract_is_active == "Y" ? true : false;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onResetForm: function() {
      this.btenable = false;
      this.submitted = false;
      this.contract_name = "";
      this.contract_description = "";
      this.contract_value = 0;
      this.contract_is_percentage = true;
      this.contract_is_active = true;
    },
    onFinalSubmit() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          this.btenable = true;
          let payload = {
            contract_id: this.contract_id,
            contract_name: this.contract_name,
            contract_description: this.contract_description,
            contract_value: this.contract_value,
            contract_is_percentage: this.contract_is_percentage ? "Y" : "N",
            contract_is_active: this.contract_is_active ? "Y" : "N"
          };
          DistributorService.UpdateMasterContract(payload)
            .then(response => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.$validator.reset();
                this.onResetForm();
                this.$router.push({
                  path: "/distributor/contract"
                });
                this.$toasted.show(data.message);
              } else {
                if (data.error && data.error.sqlMessage) {
                  this.$toasted.show(data.error.sqlMessage);
                } else {
                  this.$toasted.show(data.message);
                }
              }
            })
            .catch(this._CatchError);
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/ContractComponents/editContract.vue